export * from './DropzoneTab.types';
export { default as DropzoneTab } from './DropzoneTab';
